import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCyJXCL0jj95-x8Q9Ct_VqIDHSKxzRlhRs",
  authDomain: "tejas-crusher.firebaseapp.com",
  projectId: "tejas-crusher",
  storageBucket: "tejas-crusher.firebasestorage.app",
  messagingSenderId: "906398955549",
  appId: "1:906398955549:web:561c9b594c1892cdc8eef4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;